var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCenterLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.3125 26.2341V15H64.6875V26.2341C81.5608 28.4782 94.6875 42.6659 94.6875 60C94.6875 77.3341 81.5608 91.5218 64.6875 93.7659V105H55.3125V93.7659C38.4392 91.5218 25.3125 77.3341 25.3125 60C25.3125 42.6659 38.4392 28.4782 55.3125 26.2341ZM55.3125 35.7211C43.5128 37.8718 34.6875 47.9932 34.6875 60C34.6875 72.0068 43.5128 82.1282 55.3125 84.2789V35.7211ZM64.6875 84.2789C76.4872 82.1282 85.3125 72.0068 85.3125 60C85.3125 47.9932 76.4872 37.8718 64.6875 35.7211V84.2789Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterLine);
export default __webpack_public_path__ + "static/media/center-line.187f8dc68faa1446ac5438a602a053a5.svg";
export { ForwardRef as ReactComponent };